
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [Themeable],
})
export default class SyncDNSDialog extends Vue {
  @Prop({ required: false }) public domain!: string;

  public visible: boolean = true;

  public step: number = 0;

  public get message(): string {
    if (!this.domain) {
      return 'Are you sure you want to start synchronization of all dns zones?';
    }

    return `Are you sure you want to start synchronization of ${this.domain} zone?`;
  }

  public syncDNS(): void {
    this.$emit('syncDNS', this.step);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
